import { IMenu, IRecoveryPassToken } from './model';
import appmenu from '../../appmenu.json';
import { Roles } from '../api/seguridad/model/IRol';
import Common from '../common';
import { UsuarioLoginInfoOut } from '../../model/seguridad';

const SESSION_USER = 'CNET-BO.Seguridad.CurrentUser';

class SecurityService {

  constructor() {
    // existe previamente un usuario logueado ??
    const json = localStorage.getItem(SESSION_USER);
    if (json)
      this.User = JSON.parse(json) as UsuarioLoginInfoOut;
  }

  /** Usuario logueado */
  User : UsuarioLoginInfoOut | undefined;

  /**
   * Pide un Token de conexión de acceso
   * @param user Nombre del usuario
   * @param pass Contraseña del usuario
   */
  Login = async (user: UsuarioLoginInfoOut) : Promise<void> => new Promise((res,rej) => res(this.UpdateUser(user)));
  
  /** Desconecta al usuario logueado */
  Logout = () => this.UpdateUser(undefined);

  /** Actualiza la info del usuario */
  UpdateUser(payload?: UsuarioLoginInfoOut) {
    if (payload) {
      this.User = payload;
      localStorage.setItem(SESSION_USER, JSON.stringify(this.User))
    } else {
      this.User = undefined;
      localStorage.removeItem(SESSION_USER);
    }
  }

  /** devuelve el menú */
  GetMenu = (includeHides? : boolean) : IMenu[] => {
    return appmenu.map(m => this.AccessMenu(m as any, includeHides)).filter(m => !!m) as IMenu[];
  }

  private AccessMenu = (menu: IMenu, includeHides? : boolean) : IMenu | undefined => {
    if (!includeHides && menu.hide) return undefined;    
    if (!this.HasPermiso(menu.access)) return undefined;

    const res = { ...{ }, ...menu } as IMenu;

    if (res.menus) {
      res.menus = res.menus.map(m => this.AccessMenu(m, includeHides)).filter(m => !!m) as IMenu[];
      res.menus = !res.menus || res.menus.length < 1 ? undefined : res.menus;
    }

    return res;
  }

  /** devuelve los menús en forma de array */
  GetMenuArray = (includeHides? : boolean) : IMenu[] => {
    const map = (menu: any) : IMenu => menu as IMenu;
    const extract = (menu: any) : void => {
      if (!menu.hide) menus.push(map(menu));
      if ((menu?.menus?.length ?? 0) > 0) {
        menu.menus.forEach((submenu:any) => extract(submenu));
      }
    };

    const menus : IMenu[] = [];
    appmenu.forEach(m => {
      extract(m);
    })

    return menus;
  }
  
  /** indica si se tiene acceso a una funcionalidad */
  HasPermiso = (idpermiso?: number) : boolean => {
    if (!idpermiso) return true;  // undefined es "publico"
    return this._HasPermiso(idpermiso);
  }

  _HasPermiso = (idpermiso: number) : boolean => {
    return this._HasOnePermisoOf([idpermiso]);
  }

  /** indica si se tiene acceso a una funcionalidad */
  HasOnePermisoOf = (idpermisos: number[]) : boolean => {
    return this._HasOnePermisoOf(idpermisos);
  }

  _HasOnePermisoOf = (idpermisos: number[]) : boolean => {
    const permisos = Common.session.get("AUTHTOKEN");
    const roles = this._parseJwt(permisos)["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
    if (!roles) return false;
    var search = idpermisos.map(p => this._encodeBase62(p))
      .map(x => `(<${x}>)|(<${x}\\?)`)
      .join('|');
    return (new RegExp(search).test(`(${roles})`));
  }

  _parseJwt = (token:string) => {
    if (!token || token.length < 15) return {};  // token inválido
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
  }

  _encodeBase62 = (id: number) => {
    let value = '';
    let code = id;
    do {
      //console.log("_HasOnePermisoOf", code)
      value = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"[Math.trunc(code % 62)] + value;
      code = Math.trunc(code / 62);
    } while(code > 0);
    return value;
  }

  /** indica si se tiene acceso a una funcionalidad */
  HasOneRolOf = (idroles: Roles[]) : boolean => {
    const permisos = Common.session.get("AUTHTOKEN");
    const roles = this._parseJwt(permisos)["Roles"];
    if (!roles) return false;
    var rolesA = ((roles as string)??"").toLowerCase().split(',').filter(p => !!p);


    let busco = Object.keys(Roles).map(p => p.toLowerCase()).filter(p => idroles.map(r => `${r}`).includes(p));
    busco = [
      ...busco,
      ...busco.map(p => (Roles as any)[p].toLowerCase())
    ];

    console.log("ROLES, ", rolesA, "busco", busco, !!rolesA.find(r => busco.find(b => b === r)))
    return !!busco.find(r => rolesA.find(b => b === r));
  }

  GetPermiso = (idpermiso: number) : string | undefined => {
    const permisos = Common.session.get("AUTHTOKEN");
    const roles : string | undefined = this._parseJwt(permisos)["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
    if (!roles) return undefined;

    const search = `<${this._encodeBase62(idpermiso)}?`;
    const x = roles.indexOf(search);
    if (x < 0) return undefined;
    const y = roles.indexOf(">", x+1);
    const data = roles.substring(x + search.length, y);
    return data;
  }
  /** devuelve el valor de un permiso. Undefined si no existe, Boolean si se tiene o no, String si es un permiso especial (extradata)
  GetPermiso = (idPermiso?: number) : undefined | string | boolean => {
    if (!idPermiso) return undefined;
    if (!this.User?.allPermisos) return undefined;
    return this.User.allPermisos[idPermiso];
  } */

  /** indica si el usuario tiene un rol determinado */
  HasRol = (idrol?: number) : boolean => {
    if (!idrol) return true;
    const permisos = Common.session.get("AUTHTOKEN");
    const roles = this._parseJwt(permisos)["Roles"];
    var rolesA = (roles ?? "").toUpperCase().split(',').filter((p:string) => !!p);
    var rolName = Object.keys(Roles).find(r => (Roles as any)[r] === idrol)?.toUpperCase();
    return rolesA.includes(`${idrol}`) || rolesA.includes(rolName??'--INVALID--');
  }

  GetRecoveryPassToken = (user?: UsuarioLoginInfoOut) => {
    const hoy = new Date(new Date().setHours(new Date().getHours() + 2));
    const vencDay = `${hoy.getFullYear()}.${hoy.getMonth() + 1}.${hoy.getDate()}`;
    const vencHour = `${hoy.getHours()}.${hoy.getMinutes()}.${hoy.getSeconds()}`;
    const code = encodeURIComponent(`${user?.id}⨍${user?.login}⨍${user?.nombre ?? ''}⨍${user?.apellido ?? ''}⨍${user?.email ?? ''}⨍${vencDay}.${vencHour}⨍${user?.avatar?.url ?? ''}`);
    return btoa(code);
  }

  GetRecoveryPassTokenInfo = (token: string) : IRecoveryPassToken | undefined => {
    try {
      let code = decodeURIComponent(atob(token)).split('⨍');
      if (code.length !== 7) code = atob(token).split('⨍');
      const venc = code[5].split('.').map(p => parseInt(p));
      return {
        id: parseInt(code[0]),
        login: code[1],
        nombre: code[2],
        apellido: code[3],
        email: code[4],
        venc: new Date(venc[0], venc[1], venc[2], venc[3], venc[4], venc[5]),
        avatar: {
          nombre: 'avatar',
          url: code[6]
        }
      }
    }
    catch (ex) {
      return undefined;
    }
  }

}

const Security : SecurityService = new SecurityService();
export default Security;
export { SecurityService };